import { Box, Typography, Chip, IconButton, Button } from "@mui/material";
import { BusinessCenter } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { tokens } from "../../../store/tokens";

const CategoryItem = ({ data }) => {
  const navigate = useNavigate();
  const { banner_pic, refer, title, info, categories = [] } = data;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.5 }}
    >
      <Box
        sx={{
          height: 300,
          borderRadius: `${tokens.radius.lg}px`,
          overflow: "hidden",
          position: "relative",
          boxShadow: tokens.shadow.md,
        }}
      >
        {/* Full Image */}
        <Box
          component="img"
          src={banner_pic}
          alt={title}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "top",
            position: "absolute",
            inset: 0,
            zIndex: 1,
          }}
        />

        {/* Bottom Gradient Overlay */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            height: "60%",
            background: `linear-gradient(to top, ${tokens.color.overlay}, transparent)`,
            zIndex: 2,
          }}
        />

        {/* Bottom Content */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            zIndex: 3,
            color: tokens.color.white,
            p: 2,
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontFamily: tokens.font.heading,
              fontWeight: 700,
              fontSize: tokens.type.subtitle1.fontSize,
              color: tokens.color.white,
              textShadow: "2px 2px 3px rgba(0,0,0,0.9)",
            }}
          >
            {title || "Project Name Here"}
          </Typography>

          <Typography
            sx={{
              fontFamily: tokens.font.body,
              color: "rgba(255,255,255,0.85)",
              fontSize: tokens.type.caption.fontSize,
              lineHeight: 1.4,
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {info?.length > 30
              ? info.slice(0, 27) + "..."
              : info ||
                "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti, iure."}
          </Typography>

          {/* Chips */}
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {categories.map((cat, index) => (
              <motion.div key={index} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Chip
                  label={cat}
                  size="small"
                  sx={{
                    fontFamily: tokens.font.body,
                    fontWeight: 600,
                    bgcolor: "rgba(255,255,255,0.2)",
                    color: tokens.color.white,
                    borderRadius: `${tokens.radius.pill}px`,
                    px: 1.5,
                    fontSize: 11,
                    border: "1px solid rgba(255,255,255,0.3)",
                  }}
                />
              </motion.div>
            ))}
          </Box>

          {/* View Details Button */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            style={{ marginTop: "4px", alignSelf: "flex-start" }}
          >
            <Button
              size="small"
              variant="outlined"
              sx={{
                borderColor: "rgba(255,255,255,0.5)",
                textShadow: "2px 2px 3px rgba(0,0,0,0.9)",
                color: tokens.color.white,
                fontFamily: tokens.font.body,
                fontSize: 11,
                fontWeight: 600,
                textTransform: "none",
                px: 1.75,
                borderRadius: `${tokens.button.radius}px`,
                transition: "background-color 0.2s ease, border-color 0.2s ease",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.12)",
                  borderColor: tokens.color.white,
                },
              }}
              onClick={() => navigate("/explore/" + refer)}
            >
              View Details
            </Button>
          </motion.div>
        </Box>

        {/* Top Icon */}
        <motion.div
          whileHover={{ scale: 1.15 }}
          style={{ position: "absolute", top: 12, left: 12, zIndex: 3 }}
        >
          <IconButton
            sx={{
              bgcolor: "rgba(18,36,46,0.55)",
              color: tokens.color.white,
              transition: "background-color 0.2s ease",
              "&:hover": { bgcolor: tokens.color.teal },
              boxShadow: tokens.shadow.sm,
            }}
          >
            <BusinessCenter fontSize="small" />
          </IconButton>
        </motion.div>
      </Box>
    </motion.div>
  );
};

export default CategoryItem;